jQuery(document).ready(function($) {
  console.log("ready");
  $(".slick_slider").slick({
    prevArrow: "<button type='button' class='slick-prev'><</button>",
    nextArrow: "<button type='button' class='slick-next'>></button>",
    draggable: true,
    autoplay: true,
    autoplaySpeed: 2000
  });
  $(".slick_slider").css("opacity", 1);

  var url = window.location.href;
  $("#forgot-password").click(function(e) {
    $(".customer-login").addClass("hide");
    $(".recover-password").removeClass("hide");

    if(!url.includes("#recover")) {
      window.history.pushState('', '', url + "#recover");
    }
  });

  $(".cancel_recover").click(function(e) {
    $(".customer-login").removeClass("hide");
    $(".recover-password").addClass("hide");

    if(url.includes("#recover")) {
      window.history.pushState('', '', url.replace("#recover", ''));
    }
  });

  console.log(url);
  if(url.includes("#recover")) {
    $(".customer-login").addClass("hide");
    $(".recover-password").removeClass("hide");
  }
  else {
    $(".customer-login").removeClass("hide");
    $(".recover-password").addClass("hide");
  }

  $("#okendo-reviews-widget").bind("DOMSubtreeModified", function(e) {
    var tables = $(".okeReviews-attributeRatingsTable");

    tables.each(function() {
      var table = $(this);
      if(!table.hasClass("corrected")) {
        var rows = table.find(".okeReviews-attributeRatingsTable-row");
  
        rows.each(function() {
          if($(this).find(".okeReviews-attributeRatingsTable-row-label").text().includes("Reduced Inflammation")) {
            $(this).remove();
          }
        });
      }
      table.addClass("corrected");
    });
  });
});

document.addEventListener("cartUpdated", function(e) {
  var cart = e.detail.cart;  
  console.log("cart total price", cart.total_price);
  var f = 0;
  var progress_cnt = 0;
  var gift_cnt = 0;
  document.querySelectorAll(".scd__giftrow .gift-item").forEach(function(obj) {
    gift_cnt ++;
    var p = obj.getAttribute("data-price");
    if(cart.total_price > p) {
      progress_cnt++;
    }
    if(obj.classList.contains("added")) {  
      if(cart.total_price < p) {
        obj.classList.remove("added");

        f = 1;
      }
    }
    else {  
      if(cart.total_price > p) {
        obj.classList.add("added");

        f = 1;
      }
    }
  });
  
  console.log(progress_cnt);
  console.log(gift_cnt);
  var progress_percent = progress_cnt * 100 / gift_cnt;
  document.querySelector(".gift_progress_bar .progress_amount").style.width = progress_percent + "%";

  if(progress_percent >= 100) {
    document.querySelector(".gift_comment").classList.add("complete");
  }
  else {
    document.querySelector(".gift_comment").classList.remove("complete");
  }

  var ff = 0;
  document.querySelectorAll(".scd__giftrow .gift-item").forEach(function(obj) {
    var p = parseInt(obj.getAttribute("data-price"));
    if(cart.total_price < p && ff == 0) {
      document.querySelector(".away_price").textContent = "$" + (parseFloat(p - cart.total_price)/100).toFixed(2);
      document.querySelector(".away_title").textContent = obj.getAttribute("data-title");
      ff = 1;
    }
  });
});

$(document).on("DOMSubtreeModified", "[data-pf-type='ProductATC'] span", function(e) {
  if($(this).text() == 'Thank you!') {
    $(document).trigger("cartUpdated");
  }
});

$(document).on("DOMSubtreeModified", "[data-element='oct-quiz-resultitem'] button", function(e) {
  if($(this).text() == 'View cart') {
    console.log("View Cart");
    $(document).trigger("cartUpdated");
    $("#main-header [href='/cart']").trigger("click");
  }
});